module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audit-container"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v("返回\n          ")]), _vm._v(" "), _c('h2', {
    staticClass: "page-title"
  }, [_vm._v("订单审核")])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-center"
  }, [_vm._v("\n          订单号：" + _vm._s(_vm.order.orderSn) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getOrderStateTagType(_vm.order.orderState),
      "size": "medium"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getOrderStateName(_vm.order.orderState)) + "\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "overview-section"
  }, [_c('div', {
    staticClass: "overview-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("订单金额")]), _vm._v(" "), _c('div', {
    staticClass: "item-value amount"
  }, [_vm._v("￥" + _vm._s(_vm.order.orderAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.order.createTime))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("客户名称")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.order.customer.customerName))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("支付状态")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getPaymentTagType(_vm.order.paymentStatus),
      "size": "small"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.order.paymentStatus) + "\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overview-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("操作员")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.order.employee.adminName))])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "info-section"
  }, [_c('el-card', {
    staticClass: "info-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_vm._v("客户与发货信息")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("客户名称：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.customer.customerName))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value",
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.order.customer.phoneNumber)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.order.customer.phoneNumber) + "\n                      "), _c('i', {
    staticClass: "el-icon-document-copy copy-icon"
  })])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("销售渠道：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.gettypeNameById(_vm.order.customer.typeId)))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("客户级别：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.getlabelNameById(_vm.order.customer.labelId)))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("客户来源：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.getsourceNameById(_vm.order.customer.sourceId)))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("发货方式：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.logisticsMethods))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("快递公司：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.logisticsCompanies))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("快递单号：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value",
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.order.trackingNumber)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.order.trackingNumber) + "\n                      "), _c('i', {
    staticClass: "el-icon-document-copy copy-icon"
  })])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("收货地址：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.shippingAddress))])])]), _vm._v(" "), (_vm.order.remarks) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("快递备注：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.remarks))])])]) : _vm._e(), _vm._v(" "), (_vm.order.notes) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("订单备注：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.notes))])])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('el-card', {
    staticClass: "info-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-goods"
  }), _vm._v(" "), _c('span', [_vm._v("产品信息")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "product-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.productList,
      "border": "",
      "size": "small",
      "empty-text": '暂无产品',
      "element-loading-text": "加载中...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "align": 'left',
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "picture",
      "label": "产品图片",
      "align": 'center',
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.picture,
            "preview-src-list": [scope.row.picture],
            "alt": "产品图片",
            "fit": "cover",
            "lazy": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "产品价格",
      "align": 'right',
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costPrice",
      "label": "售价",
      "align": 'right',
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNum",
      "label": "数量",
      "align": 'center',
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salePrice",
      "label": "成交价",
      "align": 'right',
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderAmount",
      "label": "金额",
      "align": 'right',
      "width": "90"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-summary"
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', [_vm._v("总数量: "), _c('b', [_vm._v(_vm._s(_vm.totalOrderNum))]), _vm._v(" 箱")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-item primary"
  }, [_c('span', [_vm._v("订单总金额: "), _c('b', [_vm._v("￥" + _vm._s(_vm.totalOrderAmount))])])])])], 1)]), _vm._v(" "), _c('el-card', {
    staticClass: "info-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-bank-card"
  }), _vm._v(" "), _c('span', [_vm._v("回款信息")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("支付方式：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.payType))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("支付状态：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getPaymentTagType(_vm.order.paymentStatus),
      "size": "small"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.order.paymentStatus) + "\n                      ")])], 1)])]), _vm._v(" "), (_vm.order.remarks) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("收款备注：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.order.remarks))])])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("收款凭证：")]), _vm._v(" "), _c('div', {
    staticClass: "receipt-container"
  }, [(_vm.order.receipt && _vm.order.receipt.length > 0) ? _c('div', {
    staticClass: "receipt-row"
  }, _vm._l((_vm.order.receipt), function(url, index) {
    return _c('el-image', {
      key: index,
      staticClass: "receipt-thumb",
      attrs: {
        "src": url,
        "preview-src-list": _vm.order.receipt,
        "z-index": 2000,
        "fit": "cover",
        "lazy": ""
      }
    })
  }), 1) : _c('div', {
    staticClass: "no-images-message"
  }, [_vm._v("\n                        暂无收款凭证\n                      ")])])])])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-section"
  }, [_c('el-card', {
    staticClass: "audit-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" "), _c('span', [_vm._v("审核操作")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('el-form', {
    ref: "orderExamine",
    attrs: {
      "model": _vm.orderExamine,
      "label-width": "80px",
      "rules": _vm.orderExamineRules,
      "validate-on-rule-change": false,
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "findingOfAudit",
      "label": "审核结果"
    }
  }, [_c('el-radio-group', {
    staticClass: "radio-group",
    model: {
      value: (_vm.orderExamine.findingOfAudit),
      callback: function($$v) {
        _vm.$set(_vm.orderExamine, "findingOfAudit", $$v)
      },
      expression: "orderExamine.findingOfAudit"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "border": ""
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "border": ""
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), (_vm.orderExamine.findingOfAudit === 1) ? _c('div', [(_vm.order.orderState === 0) ? _c('el-form-item', {
    attrs: {
      "label": "复审人",
      "prop": "intermediateReviewer"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择复审人",
      "filterable": ""
    },
    model: {
      value: (_vm.orderExamine.intermediateReviewer),
      callback: function($$v) {
        _vm.$set(_vm.orderExamine, "intermediateReviewer", $$v)
      },
      expression: "orderExamine.intermediateReviewer"
    }
  }, _vm._l((_vm.examines), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.adminName,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.order.orderState === 1) ? _c('el-form-item', {
    attrs: {
      "label": "终审人",
      "prop": "finalReviewer"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择终审人",
      "filterable": ""
    },
    model: {
      value: (_vm.orderExamine.finalReviewer),
      callback: function($$v) {
        _vm.$set(_vm.orderExamine, "finalReviewer", $$v)
      },
      expression: "orderExamine.finalReviewer"
    }
  }, _vm._l((_vm.examines), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.adminName,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.order.orderState === 0) ? _c('el-form-item', {
    attrs: {
      "label": "初审意见",
      "prop": "juniorReviewerNotes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入初审意见...",
      "resize": "vertical"
    },
    model: {
      value: (_vm.orderExamine.juniorReviewerNotes),
      callback: function($$v) {
        _vm.$set(_vm.orderExamine, "juniorReviewerNotes", $$v)
      },
      expression: "orderExamine.juniorReviewerNotes"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.order.orderState === 1) ? _c('el-form-item', {
    attrs: {
      "label": "复审意见",
      "prop": "intermediateReviewerNotes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入复审意见...",
      "resize": "vertical"
    },
    model: {
      value: (_vm.orderExamine.intermediateReviewerNotes),
      callback: function($$v) {
        _vm.$set(_vm.orderExamine, "intermediateReviewerNotes", $$v)
      },
      expression: "orderExamine.intermediateReviewerNotes"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.order.orderState === 7) ? _c('el-form-item', {
    attrs: {
      "label": "终审意见",
      "prop": "finalReviewerNotes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入终审意见...",
      "resize": "vertical"
    },
    model: {
      value: (_vm.orderExamine.finalReviewerNotes),
      callback: function($$v) {
        _vm.$set(_vm.orderExamine, "finalReviewerNotes", $$v)
      },
      expression: "orderExamine.finalReviewerNotes"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.orderExamine.findingOfAudit === 2) ? _c('el-form-item', {
    attrs: {
      "label": "拒绝原因",
      "prop": "refuse"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入详细拒绝理由，便于再次修改...",
      "resize": "vertical"
    },
    model: {
      value: (_vm.orderExamine.refuse),
      callback: function($$v) {
        _vm.$set(_vm.orderExamine, "refuse", $$v)
      },
      expression: "orderExamine.refuse"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-actions-wrapper"
  }, [_c('el-form-item', {
    staticClass: "form-actions"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    on: {
      "click": _vm.examineOrder
    }
  }, [_vm._v("提交审核")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('el-card', {
    staticClass: "timeline-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('span', [_vm._v("审核记录")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body timeline-body"
  }, [_c('el-timeline', {
    staticClass: "audit-timeline",
    attrs: {
      "reverse": false
    }
  }, _vm._l((_vm.orderTimeList), function(item, index) {
    return _c('el-timeline-item', {
      key: index,
      staticClass: "timeline-item",
      attrs: {
        "color": _vm.getColor(item, index),
        "line-style": {
          borderWidth: '1px'
        },
        "size": "normal"
      }
    }, [_c('div', {
      staticClass: "timeline-item-wrapper"
    }, [_c('div', {
      staticClass: "timeline-item-header"
    }, [_c('span', {
      staticClass: "timeline-time"
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('el-tag', {
      staticClass: "timeline-tag",
      attrs: {
        "type": _vm.getTagType(item, index),
        "size": "mini"
      }
    }, [_vm._v("\n              " + _vm._s(item.operateType) + "\n            ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "timeline-content"
    }, [_vm._v("\n            " + _vm._s(item.content) + "\n          ")])])])
  }), 1), _vm._v(" "), (!_vm.orderTimeList || _vm.orderTimeList.length === 0) ? _c('div', {
    staticClass: "empty-timeline"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v("暂无审核记录")])]) : _vm._e()], 1)])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b347c794"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/noticeMag/examine.vue
// module id = 1034
// module chunks = 3